<template>
  <div class="gd-read">
    <label class="form-label">{{ label }}</label>
    <div class="gd-read-value" :class="{'text-gray': empty}">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: '—',
    },
  },
  computed: {
    empty() {
      return this.value === null || this.value === undefined || this.value === '';
    },
    text() {
      return this.empty ? this.placeholder : this.value;
    },
  },
};
</script>
